import React from 'react';

import { Badge } from 'DesignSystem/ui/badge';
import { cn } from 'DesignSystem/utils';

export type EventDetailTab = 'overview' | 'items';

type EventDetailTabsProps = {
  activeTab: EventDetailTab;
  onTabChange: (tab: EventDetailTab) => void;
  itemsCount: number;
};

export default function EventDetailTabs({ activeTab, onTabChange, itemsCount }: EventDetailTabsProps) {
  return (
    <nav className="ml-2 mt-4 flex flex-row items-center justify-start space-x-6 overflow-x-auto" role="tablist">
      <TabButton isActive={activeTab === 'overview'} onClick={() => onTabChange('overview')}>
        Overview
      </TabButton>
      <TabButton isActive={activeTab === 'items'} onClick={() => onTabChange('items')}>
        <div className="flex items-center">
          Items
          <Badge variant="natural" size="small" className="ml-1">
            {itemsCount}
          </Badge>
        </div>
      </TabButton>
    </nav>
  );
}

function TabButton({
  isActive,
  onClick,
  children,
}: {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      onClick={onClick}
      className={cn(
        'relative pb-3 pt-2 text-zinc-500 after:absolute after:inset-x-0 after:bottom-0 after:h-[2px] hover:after:bg-indigo-600/40',
        isActive && 'border-b-2 border-indigo-600 font-medium text-zinc-900 after:bg-indigo-600'
      )}
    >
      {children}
    </button>
  );
}
